import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@common/components/button';
import Dropdown from '@common/components/dropdown';
import ConfirmButton from '@common/components/confirm-button';

interface CompanyValueActionsProps {
  onEdit: () => void;
  onDelete: () => void;
}

const CompanyValueActions = ({ onEdit, onDelete }: CompanyValueActionsProps) => {

  const { t } = useTranslation();

  return (
    <div className="company-value-actions">
      <Dropdown
        alignRight
        toggle={(<Button icon="more_vert" />)}
      >
        <Dropdown.Item onClick={onEdit}>
          {t('organisation:company_values_actions_edit')}
        </Dropdown.Item>

        <ConfirmButton
          danger
          title={t('organisation:company_values_actions_delete_modal_title')}
          onConfirm={onDelete}
          confirmText={t('organisation:user_actions_delete_confirm_text')}
        >
          <Dropdown.Item onClick={onDelete}>
            {t('organisation:company_values_actions_delete')}
          </Dropdown.Item>
        </ConfirmButton>
      </Dropdown>
    </div>
  );
};

export default CompanyValueActions;
